export const GET_REASON_CODE_DATA = 'GET_REASON_CODE_DATA'
export const GET_REASON_CODE_DATA_ERR = 'GET_REASON_CODE_DATA_ERR'